module.exports = __webpack_public_path__ + "img/logo.0151873d.png";